import API from '../api/Http'
import * as EndPoints from '../api/EndPoints'
import { message } from 'antd'
import { RESPONSE_MESSAGE } from '../utils/constants'

const FETCH_HEROFOLLOWER_REQUEST = 'HeroLink/FETCH_HEROFOLLOWER_REQUEST'
const FETCH_HEROFOLLOWER_SUCCESS = 'HeroLink/FETCH_HEROFOLLOWER_SUCCESS'
const FETCH_HEROFOLLOWER_FAILURE = 'HeroLink/FETCH_HEROFOLLOWER_FAILURE'

const FETCH_HEROFOLLOWING_REQUEST = 'HeroLink/FETCH_HEROFOLLOWING_REQUEST'
const FETCH_HEROFOLLOWING_SUCCESS = 'HeroLink/FETCH_HEROFOLLOWING_SUCCESS'
const FETCH_HEROFOLLOWING_FAILURE = 'HeroLink/FETCH_HEROFOLLOWING_FAILURE'


// Initialize State
const initialState = {
  isLoading: true,
  error: {},
  heroFollowerList: [],
  heroFollowingList: [],
}

// Default Reducer
const heroLink = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_HEROFOLLOWER_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_HEROFOLLOWER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        heroFollowerList: action.payload
      }
    case FETCH_HEROFOLLOWER_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
      case FETCH_HEROFOLLOWING_REQUEST:
        return {
          ...state,
          isLoading: true
        }
      case FETCH_HEROFOLLOWING_SUCCESS:
        return {
          ...state,
          isLoading: false,
          heroFollowingList: action.payload
        }
      case FETCH_HEROFOLLOWING_FAILURE:
        return {
          ...state,
          error: action.error,
          isLoading: false
        }
    default:
      return state
  }
}

export default heroLink

// Action Creators
export const fetchHeroFollowerList = (id) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_HEROFOLLOWER_REQUEST
      })

      const response = await API.get(EndPoints.HEROLINK+ `/getFollower`+ `/${id}`)
      dispatch({
        type: FETCH_HEROFOLLOWER_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: FETCH_HEROFOLLOWER_FAILURE
      })
    }
  }
}
export const fetchHeroFollowingList = (id) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_HEROFOLLOWING_REQUEST
      })

      const response = await API.get(EndPoints.HEROLINK+ `/getFollowing`+ `/${id}`)
      dispatch({
        type: FETCH_HEROFOLLOWING_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: FETCH_HEROFOLLOWING_FAILURE
      })
    }
  }
}






